export default __webpack_public_path__ + "static/media/dozule14.dc0babd0.jpg";